/* 통화 기호·숫자 포맷 공통 헬퍼.
 *
 * 시장별로 (1) 통화 기호, (2) 기호 위치, (3) 숫자 그룹/소수 구분자가 다르다.
 *   - uk:  £1,499.00      (기호 앞, 천단위 ',' 소수 '.')
 *   - ca·au: $1,499.00    (기호 앞, en 포맷)
 *   - de:  1.499,00 €     (기호 뒤, 천단위 '.' 소수 ',' — 독일식)
 * 모든 카드 포매터가 본 헬퍼를 경유하여 일관된 표기를 보장한다. */

/** 숫자 뒤(suffix)에 공백과 함께 배치하는 통화 기호 집합. */
const _SUFFIX_SYMBOLS = new Set(["€"]);

/* 통화 기호 → 숫자 포맷 BCP47 locale.  미지정 기호는 런타임 기본(en 류,
 * 1,499.00).  오픈 시장 중 유로(€)만 독일식(1.499,00)을 쓴다. */
const _NUMBER_LOCALE: Record<string, string> = {
  "€": "de-DE",
};

/* ISO 4217 코드 → 표시 기호.  백엔드 ``shared/utils/locale._CURRENCY_SYMBOLS``
 * 와 동일 규칙.  대부분의 카드는 백엔드가 ``symbol`` 을 내려주지만, 주문 카드는
 * ``currency`` 코드만 받으므로 프론트에서 변환이 필요하다. */
const _CURRENCY_SYMBOLS: Record<string, string> = {
  GBP: "£",
  EUR: "€",
  USD: "$",
  CAD: "$",
  AUD: "$",
};

/** ISO 4217 통화 코드 → 표시 기호.  미매핑 코드는 ``"<CODE> "`` 로 폴백. */
export function currencySymbol(currency?: string): string {
  if (!currency) return "£";
  const code = currency.toUpperCase();
  return _CURRENCY_SYMBOLS[code] ?? `${code} `;
}

/** 통화 기호에 맞는 숫자 포맷(천단위/소수 구분자)으로 금액을 문자열화한다. */
export function formatAmount(amount: number, symbol: string): string {
  return amount.toLocaleString(_NUMBER_LOCALE[symbol], {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

/** 포맷된 금액 문자열과 통화 기호를 시장 관례에 맞게 결합한다. */
export function joinMoney(symbol: string, amountText: string): string {
  return _SUFFIX_SYMBOLS.has(symbol)
    ? `${amountText} ${symbol}`
    : `${symbol}${amountText}`;
}

/** 금액 + 통화 기호를 시장 관례(숫자 포맷·기호 위치)에 맞게 완성한다. */
export function formatMoney(amount: number, symbol: string): string {
  return joinMoney(symbol, formatAmount(amount, symbol));
}
